import { Icon } from 'semantic-ui-react'

export const displaySuccess = (success: boolean) => (
  <Icon name={success ? 'check' : 'close'} color={success ? 'green' : 'red'} />
)
